import React from "react";
import { FaGreaterThan } from "react-icons/fa"; // Import the "View More" icon
import "../css/organic-social-metrics.css"; // Assuming this file contains necessary styles
import { getImgSrc } from "../../../../helpers/getImgSrc";
import { useNavigate } from "react-router-dom";
import { getPlatformName } from "../../../../helpers/getPlatformName";


const OrganicSocialMetricsCard = ({ metricsdata,platform_id }) => {

  const navigate=useNavigate()
  return (
    <div className="organic-social-metrics-card">
      <div className="d-flex gap-3 flex-column">
        <div className="">
          <div className="row g-3">
            <div className="col-md-2">
              <div
                className="rounded-2 custom_border"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100px", // Keep this height consistent with the content
                  overflow: "hidden",
                }}
              >
                <img
                  src={metricsdata?.url?metricsdata?.url:getImgSrc("post", "png")}
                  alt=""
                  style={{
                    width: "100%",
                    height: "100%",
                    // objectFit: "cover",
                 
                     // Ensure the image covers the container without distortion
                  }}
                />
              </div>
            </div>

            <div className="col-md-10 d-flex flex-column justify-content-between" >
              {/* Text Section */}
              <div
                className="text_color_tertiary border_bottom pb-3"
                style={{
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                  display: "block",
                }}
              >
                {metricsdata?.message}
              </div>

              {/* Metrics Section */}
              <div className="row d-flex align-items-center g-2 ">
                {/* Pageviews section */}
                {getPlatformName(platform_id)==="Instagram"?<>
                      <div className="col-md-3 col-6">
                  <div className="d-flex gap-2">
                    <p className="mb-0 organic-social-metrics-value">
                      {/* {metricsdata.metrics_data?.reach ?? 0} */}
                      {Number(String(metricsdata.metrics_data?.reach).replace(/[^\d.-]/g, "") || 0).toLocaleString("en-US")}
                    </p>
                  </div>
                  <span className="organic-social-metrics-label">Reach</span>
                </div>

                {/* Bounce Rate section */}
                <div className="col-md-3 col-6">
                  <div className="d-flex gap-2">
                    <p className="mb-0 organic-social-metrics-value">
                  
                      {Number(String(metricsdata.metrics_data?.likes).replace(/[^\d.-]/g, "") || 0).toLocaleString("en-US")}
                    </p>
                  </div>
                  <span className="organic-social-metrics-label">Likes</span>
                </div>

                {/* Engagement Rate section */}
                <div className="col-md-3 col-6">
                  <div className="d-flex gap-2">
                    <p className="mb-0 organic-social-metrics-value">
                     
                      {Number(String(metricsdata.share).replace(/[^\d.-]/g, "") || 0).toLocaleString("en-US")}
                    </p>
                  </div>
                  <span className="organic-social-metrics-label">Share</span>
                </div>

                </>:<>
                 <div className="col-md-3 col-6">
                  <div className="d-flex gap-2">
                    <p className="mb-0 organic-social-metrics-value">
                      {Number(String(metricsdata.clicks).replace(/[^\d.-]/g, "") || 0).toLocaleString("en-US")}
                    </p>
                  </div>
                  <span className="organic-social-metrics-label">Clicks</span>
                </div>

                {/* Bounce Rate section */}
                <div className="col-md-3 col-6">
                  <div className="d-flex gap-2">
                    <p className="mb-0 organic-social-metrics-value">
                      {Number(String(metricsdata.impressions).replace(/[^\d.-]/g, "") || 0).toLocaleString("en-US")}
                    </p>
                  </div>
                  <span className="organic-social-metrics-label">Impressions</span>
                </div>

                {/* Engagement Rate section */}
                <div className="col-md-3 col-6">
                  <div className="d-flex gap-2">
                    <p className="mb-0 organic-social-metrics-value">
                      {Number(String(metricsdata.share).replace(/[^\d.-]/g, "") || 0).toLocaleString("en-US")}
                    </p>
                  </div>
                  <span className="organic-social-metrics-label">Share</span>
                </div>

                </>}
               

                {/* View More button section */}
                <div className="col-md-3 d-flex justify-content-end align-self-end">
                  <button
                    onClick={() => {
                      // Handle navigation here, e.g., using `navigate` from react-router-dom
                      navigate(`view-more/${metricsdata?.post_id}/${platform_id}`)
                    }}
                    className="btn_small_primary"
                  >
                    View More <FaGreaterThan />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrganicSocialMetricsCard;
